// extracted by mini-css-extract-plugin
export var container = "BattleBoxList-module--container--b65ce";